import { API, graphqlOperation } from "aws-amplify";

import { listPlans as listPlansQuery } from "../graphql/queries";
import { createSubscription as createSubscriptionMutation } from "../graphql/mutations";
import {
  CREATE_SUBSCRIPTION_SUCCESS,
  PLANS_LOADED,
  PLANS_LOADED_ERROR,
} from "./ActionTypes";

export const getListPlans = () => async (dispatch) => {
  try {
    const { data } = await API.graphql({
      ...graphqlOperation(listPlansQuery),
      authMode: "AWS_IAM",
    });

    const listPlansData = data && data.listPlans;
    const listPlans =
      listPlansData && listPlansData.items
        ? listPlansData.items.sort(
            (a, b) =>
              parseFloat(a.pricePerMonth.amount) -
              parseFloat(b.pricePerMonth.amount)
          )
        : [];

    dispatch({
      type: PLANS_LOADED,
      payload: listPlans,
    });

    return listPlans;
  } catch (err) {
    dispatch({
      type: PLANS_LOADED_ERROR,
      payload: err.errors[0].message,
    });
    throw new Error(`Error get list plans: ${err.errors[0].message}`);
  }
};

export const createSubscription = (params) => async (dispatch) => {
  try {
    const {
      data: { createSubscription },
    } = await API.graphql(
      {
        ...graphqlOperation(createSubscriptionMutation, params),
        authMode: "AWS_IAM",
      },
      []
    );

    if (createSubscription) {
      dispatch({ type: CREATE_SUBSCRIPTION_SUCCESS });
    }
  } catch (err) {
    const detailError = err.errors[0]?.errorInfo
      ? err.errors[0].errorInfo.detail
      : err.errors[0].message;
    const message =
      typeof detailError === "string"
        ? detailError
        : detailError[Object.keys(detailError)[0]][0];
    throw new Error(message);
  }
};
